import request from '@/utils/request'

const url = '/dkmall/payment-settings/wire-transfers'
export function getWireTransfer (type) {
  return request({ url: `${url}/${type}`, method: 'get' })
}
export function saveWireTransfer (type, data) {
  return request({ url: `${url}/${type}`, method: 'put', data })
}
